import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { JsonSchemaService } from '../../../core/json-form/services/json-schema.service';

@Component({
   selector: 'app-json-form-cont',
   templateUrl: './json-form-cont.component.html',
   styleUrls: ['./json-form-cont.component.scss'],
   providers: [JsonSchemaService]
})
export class JsonFormContComponent implements OnInit {

   private _schemaFile = 'schema';
   private _jsonFile: any = null;
   public _jsonSchema: any = null;
   public _jsonLayout: any = null;
   public _jsonData: any = null;

   constructor(
      private schemaService: JsonSchemaService,
      private http: HttpClient,
      private route: ActivatedRoute,
   ) { }

   ngOnInit() {
      // Subscribe to query string to detect schema to load
      this.route.queryParams
         .subscribe(params => {
            if (params['file']) {
               this._schemaFile = params['file'];
               this.loadJsonFile();
            }
         });
   }

   loadJsonFile(
      filename: string = this._schemaFile
   ) {
      const filepath = `assets/schema/${filename}.json`;
      console.log('Load file:' + filepath);
      this.http
         .get(filepath, { responseType: 'json' })
         .subscribe((fs: any) => {
            this._jsonFile = fs;
            if (fs.schema) {
               this._jsonSchema = fs.schema;
            }
            if (fs.layout) {
               this._jsonLayout = fs.layout;
            }
            if (fs.data) {
               this._jsonData = fs.data;
            }
         });
   }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/json-form/compc/json-form-cont/json-form-cont.component.ts